module.exports = __webpack_public_path__ + "static/media/videojuegosPizarra.ec7e2559.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/videojuegosPizarra.png
// module id = 376
// module chunks = 0